import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BasicAuthHttpInterceptorService implements HttpInterceptor{

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler){

    if ( sessionStorage.getItem('loginUserName') && sessionStorage.getItem('basicauth') ){
      req = req.clone({
        setHeaders: {
          Authorisation: sessionStorage.getItem('basicauth')
        }
      })
     // console.log('Rest HTTP Call interceptor');
     // console.log(req.url);
      /*const baseUrl = "/Cadence";
      req = req.clone({ url: `${baseUrl}${req.url}` });*/
    }
    return next.handle(req);
  }
}
